import { Fragment, ReactElement } from 'react';
import RegistrationCivilUnionNonResidentDetailNotificationCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-civil-union-non-resident/detail';
import { IdAmbito } from 'shell/constants/id-ambito';

const RegistrationCivilUnionDetailNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <RegistrationCivilUnionNonResidentDetailNotificationCivilStatusShared
        scope={IdAmbito.Mutazioni}
      />
    </Fragment>
  );
};

RegistrationCivilUnionDetailNotificationsCivilStatusPage.displayName =
  'Research Civil Union Detail Notifications Page component';

export default RegistrationCivilUnionDetailNotificationsCivilStatusPage;
